"use strict";

exports.__esModule = true;
exports.StyledProgressBar = exports.StyledProgress = void 0;

var _stitches = require("../theme/stitches.config");

var _color = require("../utils/color");

var _theme$colors, _theme$colors$primary, _theme$colors2, _theme$colors2$second, _theme$colors3, _theme$colors3$succes, _theme$colors4, _theme$colors4$warnin, _theme$colors5, _theme$colors5$error;

const indeterminateAnimation = (0, _stitches.keyframes)({
  '0%': {
    left: '-40%'
  },
  '100%': {
    left: '100%'
  }
});
const StyledProgress = (0, _stitches.styled)('div', {
  margin: 0,
  padding: 0,
  width: '100%',
  position: 'relative',
  overflow: 'visible',
  variants: {
    color: {
      defuault: {
        $$progressColor: '$colors$primary',
        $$progressShadowColor: '$colors$primaryLight'
      },
      primary: {
        $$progressColor: '$colors$primary',
        $$progressShadowColor: '$colors$primaryLight'
      },
      secondary: {
        $$progressColor: '$colors$secondary',
        $$progressShadowColor: '$colors$secondaryLight'
      },
      success: {
        $$progressColor: '$colors$success',
        $$progressShadowColor: '$colors$successLight'
      },
      warning: {
        $$progressColor: '$colors$warning',
        $$progressShadowColor: '$colors$warningLight'
      },
      error: {
        $$progressColor: '$colors$error',
        $$progressShadowColor: '$colors$errorLight'
      },
      gradient: {
        $$progressColor: '$colors$gradient',
        $$progressShadowColor: '$colors$primaryLight'
      }
    },
    status: {
      default: {
        bg: '$accents2'
      },
      primary: {
        bg: (0, _color.addColorAlpha)((_theme$colors = _stitches.theme.colors) == null ? void 0 : (_theme$colors$primary = _theme$colors.primary) == null ? void 0 : _theme$colors$primary.value, 0.2)
      },
      secondary: {
        bg: (0, _color.addColorAlpha)((_theme$colors2 = _stitches.theme.colors) == null ? void 0 : (_theme$colors2$second = _theme$colors2.secondary) == null ? void 0 : _theme$colors2$second.value, 0.2)
      },
      success: {
        bg: (0, _color.addColorAlpha)((_theme$colors3 = _stitches.theme.colors) == null ? void 0 : (_theme$colors3$succes = _theme$colors3.success) == null ? void 0 : _theme$colors3$succes.value, 0.2)
      },
      warning: {
        bg: (0, _color.addColorAlpha)((_theme$colors4 = _stitches.theme.colors) == null ? void 0 : (_theme$colors4$warnin = _theme$colors4.warning) == null ? void 0 : _theme$colors4$warnin.value, 0.2)
      },
      error: {
        bg: (0, _color.addColorAlpha)((_theme$colors5 = _stitches.theme.colors) == null ? void 0 : (_theme$colors5$error = _theme$colors5.error) == null ? void 0 : _theme$colors5$error.value, 0.2)
      }
    },
    size: {
      xs: {
        $$progressHeight: '$space$2',
        height: '$$progressHeight',
        br: '$$progressHeight'
      },
      sm: {
        $$progressHeight: '$space$4',
        height: '$$progressHeight',
        br: '$$progressHeight'
      },
      md: {
        $$progressHeight: '$space$8',
        height: '$$progressHeight',
        br: '$$progressHeight'
      },
      lg: {
        $$progressHeight: '$space$10',
        height: '$$progressHeight',
        br: '$$progressHeight'
      },
      xl: {
        $$progressHeight: '$space$11',
        height: '$$progressHeight',
        br: '$$progressHeight'
      }
    },
    indeterminated: {
      true: {
        overflow: 'hidden'
      }
    },
    squared: {
      true: {
        br: 'calc($$progressHeight * 0.25)'
      }
    }
  },
  defaultVariants: {
    color: 'defuault',
    status: 'default',
    size: 'md'
  }
});
exports.StyledProgress = StyledProgress;
const StyledProgressBar = (0, _stitches.styled)('div', {
  margin: 0,
  padding: 0,
  width: 0,
  opacity: 0,
  height: '100%',
  minWidth: 'inherit',
  bg: '$$progressColor',
  br: 'inherit',
  transition: 'width 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
  '@motion': {
    transition: 'none'
  },
  variants: {
    animated: {
      false: {
        transition: 'none'
      }
    },
    shadow: {
      true: {
        normalShadowVar: '$$progressShadowColor'
      }
    },
    striped: {
      true: {
        backgroundImage: 'linear-gradient(45deg, rgba(0, 0, 0, 0.1) 25%, transparent 25%, transparent 50%, rgba(0, 0, 0, 0.1) 50%, rgba(0, 0, 0, 0.1) 75%, transparent 75%, transparent)',
        backgroundSize: '$space$lg $space$lg'
      }
    },
    indeterminated: {
      true: {
        position: 'absolute',
        width: '0%',
        transitionProperty: 'background-color, width, left, border-color,opacity, shadow, transform',
        transitionDuration: '300ms',
        willChange: 'left',
        minWidth: '50%',
        animation: `1s ease 0s infinite normal none running ${indeterminateAnimation}`
      }
    }
  }
});
exports.StyledProgressBar = StyledProgressBar;